// The redesigned partner Accounts pages (epic ID-13255) are mounted only under this root and linked
// from no menu, so they can be exercised on their own URLs while the menu-linked pages at /accounts
// stay as they are. Pointing these at the original paths is the switch-over.
export const ENTITIES_ROOT = '/entities';
export const ACCOUNTS_PATH = `${ENTITIES_ROOT}/accounts`;
export const ACCOUNT_CREATION_PATH = `${ENTITIES_ROOT}/accounts-create`;
export const TRANSFER_PATH = `${ENTITIES_ROOT}/partner-account-transfers`;
export const ORGANIZATION_OVERVIEW_PATH = `${ENTITIES_ROOT}/organization-overview`;
